<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Your Progress</h1>

        <!-- Placeholder for progress component -->
        <v-card class="pa-4">
          <p>Progress tracking will be shown here.</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
// Would import from common-ui or db package
</script>
